import { encryptionData, decryptionData } from "../utils/Encryption";
import ComponentNavigation from "./ComponentNavigation";
import { IsQueryParamsEncryption } from '../utils/AppSetting';

export const NavigatePath = (props, params = []) => {
    const component = ComponentNavigation.filter(c => c.name === props);
    if (component.length > 0) {
        let navigationPath = component[0].path;
        params.forEach(element => {
            if (IsQueryParamsEncryption) {
                navigationPath = navigationPath + '/' + encryptionData(element,0);
            }
            else {
                navigationPath = navigationPath + '/' + element;
            }
        });
        return navigationPath;
    }
    return null;
}


export const QueryParams = (props, isEncryptedPrams = true) => {
    let queryPrams = [];
    let queryString = props.toString().split('/');
    if (queryString.length > 2) {
        queryString.forEach((value, key) => {
            if (key > 1) {
                if (IsQueryParamsEncryption && isEncryptedPrams) {
                    queryPrams.push(decryptionData(value,false));
                }
                else {
                    queryPrams.push(value);
                }
            }
        });
    }
    return queryPrams;
}
